import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Cards.css';
import Products from "./Products";
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from "react";
import axios from "axios";
import BaseURL from "../Util/BaseURL"
import { toast, ToastContainer } from 'react-toastify';
import toastify from "../Util/toastify";

const Cards = ({ data }) => {

    const[imgUrl,setImgUrl]=useState()
    const[wish,setWish]=useState()
    const[price,setPrice]=useState()
    const[username,setUsername]=useState()
    const[product_id,setProductId]=useState()
    const[quantity,setQuantity]=useState()
    const[discount,setDiscount]=useState()
    const[sellerId,setSellerId]=useState()
    const[trigger,setTrigger]=useState(false)
    const url = BaseURL
    var path=window.location.pathname

    async function getWish(){
        let proid=data.productId
        if(proid === undefined){}
        else
        {
        if((sessionStorage.getItem("c")==="User"))
        {
            var r
            r=await axios.get(`${url}GetWishId?id=${proid}&name=${sessionStorage.getItem("user")}`,{ headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
            setWish(r.data.length)
        }
    }
             
    }

    async function getImage(){
        let proid=data.productId
        if(proid === undefined){}
        else{
            const r=await axios.get(`${url}getImages?id=${proid}`)
        setImgUrl(r.data[0].url)
        setUsername(sessionStorage.getItem("user"))
        setProductId(proid)
        setQuantity(1)
        }
        
    }
    async function getPrice(){
        let proid=data.productId
        if(proid === undefined){}
        else{
            const r=await axios.get(`${url}GetPriceByID?id=${proid}`)
            setPrice(r.data[0].price)
            setDiscount(r.data[0].discount)
            setSellerId(r.data[0].sellerid)
        }
    }
    var nav = useNavigate()
    function navigate(props) {
        nav('/Products', { state: { productId: props} })
    }
    function navigateSales(props) {
        nav('/SellerPanel/SalesReport/Sales', { state: { productId: props} })
    }
    const passCart = async () =>{
        const statusFlag=true
        
        const resGet = await axios.get(`${url}getCartById?id=${product_id}&name=${username}`,{ headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
        if(resGet.data.length>0){
            let q = resGet.data[0].quantity
            q=q+1
            axios.post(`${url}UpdateCart?id=${product_id}&name=${sessionStorage.getItem("user")}&quantity=${q}`)
            toastify("Product Added to Cart","success")
        }
        else{
        const res = await axios.post(`${url}addToCart`,
        {
           username,product_id,quantity,price,sellerId
        },{ headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } }
    )
    toastify("Product Added to Cart","success")
}
}
    function toCart(){
        if(!((sessionStorage.getItem("c")==='User')||(sessionStorage.getItem("c")==='Seller')||sessionStorage.getItem("c")==='Admin'))
    {
         toastify("You need to login first","error")
         nav('/Login')
    }
    else{
    passCart()
   
    }
}
function toBuy(){
    if(!((sessionStorage.getItem("c")==='User')||(sessionStorage.getItem("c")==='Seller')||sessionStorage.getItem("c")==='Admin'))
{
     toastify("You need to login first","error")
     nav('/Login')
}
else{
    toastify("Boss is currently working on Buy Functionality. Please use Add to Cart","info")

}
}
async function removeWish(props){
    axios.delete(`${url}DeleteWish?id=${product_id}&name=${username}`,{ headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
    const r = await axios.get(
        `${url}GetWish?name=${sessionStorage.getItem("user")}`,
        { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
      );
    if(r.data.length === 1)
      nav(0)
    else
    document.getElementById(props+"card").style.display="none"
}
function wishlist(props){
    if(document.getElementById(props).style.color === "red")
    {
        document.getElementById(props).style.color="black"
        axios.delete(`${url}DeleteWish?id=${product_id}&name=${username}`,{ headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
    }
        
    else
    {
    document.getElementById(props).style.color="red"
    axios.post(`${url}AddWish`,{
        "username": sessionStorage.getItem("user"), "productid": props
    },{ headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
    }
}

useEffect(()=>{
    getWish()
    getImage()
     getPrice()
    
},[data])

     
    return (
        <>
        {data.productId? 
        <>
         <div className="col-md-4 col-12 p-4">
            <div className="card h-100"
            style={{ boxShadow: "0 1px 7px 0 rgb(0 0 0 / 50%)" }}
            id={product_id+"card"}>
                {
                    path==='/Wishlist'?<i className="fas fa-times-circle wish" style={{marginLeft:"88%",marginTop: "2%", color:"black"}} onClick={()=>removeWish(data.productId)}></i>:<></>
                }
                {
                    sessionStorage.getItem("c")==='User' && path==='/'? wish===0?
                    <>
                    <i className="fa fa-heart wish" id={data.productId} style={{marginLeft:"88%", marginTop: "2%"}} onClick={()=>wishlist(data.productId)}></i>
                    </> : <>
                    <i className="fa fa-heart wish" id={data.productId} style={{marginLeft:"88%", marginTop: "2%", color:"red"}} onClick={()=>wishlist(data.productId)}></i>
                    </>:<></>
                }
            
            
            <div className="text-center p-4 hei gx-0" key={data.id}>
                {
                    path==='/SellerPanel/SalesReport'?<>
                    <img src={imgUrl} className="card-img-top productImg" alt={data.title} height="60%"/>
                    </>:
                    <>
                    <img onClick={() => navigate(data.productId)}src={imgUrl} className="card-img-top productImg" alt={data.title} height="60%"/>
                    </>
                }
                
                <div className="card-body">
                {
                    path==='/SellerPanel/SalesReport'?<>
                    <h5 className="card-title">{(data.brand)+" "+(data.model)}</h5>
                    </>:
                    <>
                    <h5 onClick={() => navigate(data.productId)} className="card-title">{(data.brand)+" "+(data.model)}</h5>
                    </>
                }
                    <br />
                   {
                       discount>0?<>
                        <div className="row">
                        <s className="col">Price: {price}</s>
                        <b className="col ">Offer Price : {price-discount}</b>
                    </div>
                       </>:<>
                       <div className="row">
                        <b className="col">Price: {price}</b>
                    </div>
                       </>
                   }
                 <div className="d-none d-2xl-block d-xl-block d-lg-block"> 
                 {sessionStorage.getItem("c")==='User'?<>
                    
                     <a><button className="mb-1 btn btn-outline-dark buy col" onClick={()=>toBuy()}>Buy Now</button></a>
                    <a><button className="btn btn-outline-dark addcart col" onClick={()=>toCart()}>Add to Cart</button></a>
                    
                     </>:sessionStorage.getItem("c")==='Admin'?<></>:sessionStorage.getItem("c")==='Seller'?<></>:
                     <>
                     <a><button className="btn btn-outline-dark buy cardBtns">Buy Now</button></a>
                    <a><button className="btn btn-outline-dark addcart cardBtns" onClick={()=>toCart()}>Add to Cart</button></a>
                    
                     </>} 
                     {
                         path==='/SellerPanel/SalesReport'?<>
                         
                         <div className="row">
                         <b> Stocks Left : {data.quantity}</b>
                         <a><button className="btn btn-outline-dark buy cardBtns col" onClick={()=>navigateSales(data.productId)}>View Sales</button></a>
                         </div>
                         </>
                         :<></>
                     }      
                 </div>
                 <div className="d-block d-2xl-none d-xl-none d-lg-none"> 
                 {sessionStorage.getItem("c")==='User'?<>
                    <div className="row">
                    <a className="col"><button className="btn btn-outline-dark buy cardBtns" onClick={()=>toBuy()}><i className="fas fa-shopping-bag"></i></button></a>
                    <a className="col"><button className=" btn btn-outline-dark addcart cardBtns" onClick={()=>toCart()}><i className="fas fa-cart-plus"></i></button></a>
                    </div>
                     </>:sessionStorage.getItem("c")==='Admin'?<></>:sessionStorage.getItem("c")==='Seller'?<></>:
                     <>
                     <div className="row">
                     <a className="col"><button className="btn btn-outline-dark buy cardBtns"><i className="fas fa-shopping-bag" onClick={()=>toBuy()}></i></button></a>
                    <a className="col"><button className=" btn btn-outline-dark addcart cardBtns" onClick={()=>toCart()}><i className="fas fa-cart-plus"></i></button></a>
                    </div>
                     </>} 
                     {
                         path==='/SellerPanel/SalesReport'?<>
                         
                         <div className="row">
                         <b> Stocks Left : {data.quantity}</b>
                         <a><button className="btn btn-outline-dark buy cardBtns col" onClick={()=>navigateSales(data.productId)}>View Sales</button></a>
                         </div>
                         </>
                         :<></>
                     }      
                 </div>
                       
                </div>
            </div>
            </div>
            </div>
        </>
        :
        <></>}
         
            
            </>
    )
}
export default Cards